/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdApplicationHandlersAuthAuthenticateWithExternalIdState;
(function (FxIdApplicationHandlersAuthAuthenticateWithExternalIdState) {
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["Unspecified"] = 0] = "Unspecified";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedNoCredentials"] = 1] = "FailedNoCredentials";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedWrongEmailForExternalId"] = 2] = "FailedWrongEmailForExternalId";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedNeedEmailCode"] = 3] = "FailedNeedEmailCode";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedWrongCode"] = 4] = "FailedWrongCode";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedUnknownError"] = 5] = "FailedUnknownError";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedValidationError"] = 6] = "FailedValidationError";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedInviteError"] = 7] = "FailedInviteError";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedExternalIdWithoutEmail"] = 9] = "FailedExternalIdWithoutEmail";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedAccountWithoutEmail"] = 10] = "FailedAccountWithoutEmail";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedTooMuchRequestsForInvite"] = 11] = "FailedTooMuchRequestsForInvite";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedEmailTaken"] = 12] = "FailedEmailTaken";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["FailedBanned"] = 13] = "FailedBanned";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["Success"] = 99] = "Success";
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[FxIdApplicationHandlersAuthAuthenticateWithExternalIdState["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdApplicationHandlersAuthAuthenticateWithExternalIdState || (FxIdApplicationHandlersAuthAuthenticateWithExternalIdState = {}));
export function instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdState(value) {
    for (const key in FxIdApplicationHandlersAuthAuthenticateWithExternalIdState) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationHandlersAuthAuthenticateWithExternalIdState, key)) {
            if (FxIdApplicationHandlersAuthAuthenticateWithExternalIdState[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON(value) {
    return value;
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateWithExternalIdState.js.map